var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLinkedinsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1_1",
    transform: "translate(-802.000000, -566.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(485.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-3",
    transform: "translate(307.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-outline",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
    x: -1.77635684e-15,
    y: 1.77635684e-15,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22 L18.33,22 C17.2254305,22 16.33,21.1045695 16.33,20 L16.33,14.63 C16.3484158,14.1959732 16.0607234,13.8082138 15.64,13.7 C15.3996956,13.6634099 15.1553233,13.7327095 14.97,13.89 C14.7791861,14.0519366 14.6694335,14.2897339 14.67,14.54 L14.67,20 C14.67,21.1045695 13.7745695,22 12.67,22 L11,22 C9.8954305,22 9,21.1045695 9,20 L9,14.54 C9,10.9501491 11.9101491,8.04 15.5,8.04 C19.0898509,8.04 22,10.9501491 22,14.54 L22,20 C22,21.1045695 21.1045695,22 20,22 L20,22 Z M15.5,11.69 C15.6565109,11.6801198 15.8134891,11.6801198 15.97,11.69 C17.3557676,11.9565668 18.3505562,13.1789766 18.33,14.59 L18.33,20 L20,20 L20,14.54 C20,12.0547186 17.9852814,10.04 15.5,10.04 C13.0147186,10.04 11,12.0547186 11,14.54 L11,20 L12.67,20 L12.67,14.54 C12.6699614,12.973766 13.9338045,11.7009911 15.5,11.69 L15.5,11.69 Z",
    id: "Shape",
    fill: "#1D2B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,10 C2,8.8954305 2.8954305,8 4,8 L6,8 C7.1045695,8 8,8.8954305 8,10 L8,20 C8,21.1045695 7.1045695,22 6,22 Z M4,10 L4,20 L6,20 L6,10 L4,10 Z",
    id: "Shape",
    fill: "#1D2B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,7 C3.34314575,7 2,5.65685425 2,4 C2,2.34314575 3.34314575,1 5,1 C6.65685425,1 8,2.34314575 8,4 C8,5.65685425 6.65685425,7 5,7 L5,7 Z M5,3 C4.44771525,3 4,3.44771525 4,4 C4,4.55228475 4.44771525,5 5,5 C5.55228475,5 6,4.55228475 6,4 C6,3.44771525 5.55228475,3 5,3 Z",
    id: "Shape",
    fill: "#1D2B7D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLinkedinsvg);
export default __webpack_public_path__ + "static/media/Share-linkedinsvg.5940feba5cf00a054ced1c7d3588a2bc.svg";
export { ForwardRef as ReactComponent };